import Vue from 'vue';
import File from '$src/models/fileModel';

export default {
    namespaced: true,

    state: {
        allowed_files: [],
    },

    getters: {
        getAllowedFiles({allowed_files}) {
            return allowed_files;
        },

        getThumbnailUrl() {
            return (id_file = null, fallback = '') => {
                return id_file === null ? fallback :`/api/file/thumb/${btoa(id_file)}`;
            };
        },

        getContentUrl() {
            return (id_file = null, fallback = '') => {
                return id_file === null ? fallback : `/api/file/content/${btoa(id_file)}`;
            };
        },
    },

    mutations: {
        setAllowedFiles(state, value) {
            state.allowed_files = value;
        },
    },

    actions: {
        async upload({}, {file, id_user = null}) {
            let body = new FormData();
            body.append('file', file);

            if (id_user !== null) {
                body.append('id_user', id_user);
            }

            let response = await Vue.$api.fetch('/file', {
                method: 'post',
                body,
            });

            let data = {};
            let $status = response.status;
            let $success = $status >= 200 && $status < 300;

            if ($status === 413) {
                throw {
                    message: 'max-size',
                };
            }
            if ($status === 422) {
                throw {
                    message: (await response.json()).message,
                };
            }

            if ($success) {
                try {
                    let json = await response.json();
                    if (data instanceof Object) {
                        data = json;
                        await File.insertOrUpdate({data});
                    }
                } catch (e) {
                    $success = false;
                }
            }

            return File.find(data.id_file);
        },

        async fetch({}, id_file) {
            if (id_file !== null) {
                let data = await Vue.$api.get(`/file/details/${id_file}`);
                if (data.$success) {
                    await File.insert({data});
                }
            }
        },

        async delete({}, {id_file}, ...params) {
            if (id_file !== null) {
                return await Vue.$api.delete(`/file/${id_file}`, params);
            }
        },
    },
};